import { PayloadAction } from '@reduxjs/toolkit';
import { PlanboardState } from '@reducers/v2/planboard/types';

export const setPendingResetOperationAction = (
  state: PlanboardState,
  action: PayloadAction<{
    correlationId: string;
    productionOperationId: number;
    machineId: number;
  }>
) => {
  const { correlationId, productionOperationId, machineId } = action.payload;
  state.pendingResetOperations[correlationId] = {
    productionOperationId,
    machineId,
  };
};
